import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { DashboardLayoutTemplateView } from "./DashboardLayoutTemplateView";
import { DashboardLayoutTemplateViewStore } from "../../store/DashboardLayoutTemplateViewStore";
import { useStore } from "../../../../hooks";

export const DashboardLayoutTemplateViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/dashboardLayoutTemplate/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new DashboardLayoutTemplateViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <DashboardLayoutTemplateView dashboardLayoutTemplateViewStore={store} />
      </PageLayout>
    </div>
  );
});
